module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_100.37dfabf3.png";